import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getKraDataList = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/employeeperformance/kra/getkralist${qs}`, {
    headers: {
      authorization: token,
    },
  });
};

export const insertKraData = (data, token) => {
  return axios.post(`${baseUrl}/employeeperformance/kra/addMultipleKra`, data, {
    headers: {
      authorization: token,
    },
  });
};

export const getEmployeeKraById = (id, token) => {
  return axios.get(`${baseUrl}/employeeperformance/getemployeekrabyId:/${id}`, {
    headers: {
      authorization: token,
    },
  });
};
